export default "__VITE_ASSET__DCl2HJIz__"